import { Tree as AntdTree } from "antd";

const TreePolyfill: typeof AntdTree = AntdTree;

export default TreePolyfill;